module.exports = __webpack_public_path__ + "img/pic3.e37d2d19.jpg";